import {
  GET_APPOINT_NOTIFICATIONS_REQUEST,
  GET_APPOINT_NOTIFICATIONS_SUCCESS,
  GET_APPOINT_NOTIFICATIONS_FAILURE,
  GET_TIMELINE_STATUS_REQUEST,
  GET_TIMELINE_STATUS_SUCCESS,
  GET_TIMELINE_STATUS_FAILURE,
  POST_TIMELINE_STATUS_REQUEST,
  POST_TIMELINE_STATUS_SUCCESS,
  POST_TIMELINE_STATUS_FAILURE,
  DELETE_TIMELINE_STATUS_BY_ID_REQUEST,
  DELETE_TIMELINE_STATUS_BY_ID_SUCCESS,
  DELETE_TIMELINE_STATUS_BY_ID_FAILURE,
  GET_RECORDING_DATA_SUCCESS,
  GET_RECORDING_DATA_FAILURE,
  GET_TIMELINE_STATUS_BY_ID_REQUEST,
  GET_TIMELINE_STATUS_BY_ID_SUCCESS,
  GET_TIMELINE_STATUS_BY_ID_FAILURE,
} from '../../constants/ActionTypes'
import * as messages from '../../constants/Messages';
import * as errMessages from '../../constants/ErrorMessages';
import { formatErrorMessage } from '../../utils/utils'
const { OrderedMap } = require('immutable')


const initialState = {
  isLoadingStatuses: false,
  statuses: OrderedMap({}),
  currentId: null,
  isPostingStatus: false,
  isDeleting: false,
  shortMessage: '',
  successMessage: '',
  errorMessage: '',
  recordingsData: null,
  appointmentNotifications: OrderedMap({}),
  timelineStatus: null,
};

export default (state = initialState, action) => {
  let list;

  state = {
    ...state,
    shortMessage: '',
    successMessage: '',
    errorMessage: '',
    error: null,
    recordingsData: null,
  }

  switch (action.type) {
    case GET_TIMELINE_STATUS_REQUEST:
      return {
        ...state,
        currentId: action.payload.id.toString(),
        isLoadingStatuses: true,
        statuses: state.currentId !== action.payload.id.toString() ? OrderedMap({}) : state.statuses,
      }
    case GET_TIMELINE_STATUS_SUCCESS:
      if (state.currentId === action.payload.id.toString()) {
        list = OrderedMap({});
        action.payload.statuses.forEach(item => {
          list = list.set(item.id, item);
        })

        return {
          ...state,
          isLoadingStatuses: false,
          statuses: list
        }
      } else {
        return state;
      }
    case GET_TIMELINE_STATUS_FAILURE:
      if (state.currentId === action.payload.id.toString()) {
        return {
          ...state,
          isLoadingStatuses: false,
          error: action.payload.error,
        }
      } else {
        return state;
      }
    case POST_TIMELINE_STATUS_REQUEST:
      if (state.currentId === action.payload.id.toString()) {
        return {
          ...state,
          isPostingStatus: true,
        }
      } else {
        return state;
      }
    case POST_TIMELINE_STATUS_SUCCESS:
      if (state.currentId === action.payload.id.toString()) {
        return {
          ...state,
          statuses: state.statuses.set(action.payload.status.id, action.payload.status),
          isPostingStatus: false,
          shortMessage: messages.SAVE_SUCCESS,
        }
      } else {
        return state;
      }
    case POST_TIMELINE_STATUS_FAILURE:
      if (state.currentId === action.payload.id.toString()) {
        return {
          ...state,
          isPostingStatus: false,
          error: action.payload.error,
          errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE),
        }
      } else {
        return state;
      }
    case DELETE_TIMELINE_STATUS_BY_ID_REQUEST:
      return {
        ...state,
        isDeleting: true,
      }
    case DELETE_TIMELINE_STATUS_BY_ID_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        statuses: state.statuses.delete(action.payload.id),
        shortMessage: messages.DELETE_SUCCESS,
      }

    case DELETE_TIMELINE_STATUS_BY_ID_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload.error,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_REMOVE_FAILURE),
      }

    case GET_RECORDING_DATA_SUCCESS:
      return {
        ...state,
        recordingsData: action.payload.data,
      }
    case GET_RECORDING_DATA_FAILURE:
      return {
        ...state,
        isLoadingStatuses: false,
        error: action.payload.error,
      }
    case GET_TIMELINE_STATUS_BY_ID_REQUEST:
      return {
        ...state,
        isLoadingStatuses: true,
      }
    case GET_TIMELINE_STATUS_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingStatuses: false,
        timelineStatus: { ...action.payload.timelineStatus },
      }
    case GET_TIMELINE_STATUS_BY_ID_FAILURE:
      return {
        ...state,
        isLoadingStatuses: false,
        error: action.payload.error,
      }
    case GET_APPOINT_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        appointmentNotifications: OrderedMap({}),
      }
    case GET_APPOINT_NOTIFICATIONS_SUCCESS:
      list = OrderedMap({});
      action.payload.statuses.forEach(item => {
        list = list.set(item.id, item);
      })
      return {
        ...state,
        appointmentNotifications: list,
      }
    case GET_APPOINT_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/timeline.js